import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import videojs from "video.js";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";
import { useGlobalContext } from "store/contexts/globalContext";

export default ({
  setLoading,
  height = 640,
  width = 480,
  fluid = false,
  setWebCamData,
  maxLength = 180,
  disposeAfterRecording = true,
  onChange = () => {},
  startRecord = () => {},
}) => {
  const videoNode = useRef(null);
  const { microsoftTeamsVideoText, isSafari } = useGlobalContext();
  const ffmpeg = createFFmpeg({ log: true });
  const containerNode = useRef(null);
  const [player, setPlayer] = useState(null);
  const [videoJsOptions] = useState({
    controls: true,
    bigPlayButton: false,
    width,
    height,
    fluid,
    plugins: {
      record: {
        audio: true,
        screen: true,
        maxLength,
      },
    },
  });

  /**
   * Register Player On Load
   */
  useEffect(() => {
    const player = videojs(videoNode.current, videoJsOptions, () => {});

    if (setWebCamData) {
      setWebCamData(player);
    }

    if (width === -1) {
      containerNode.current.style.width = "100%";
    }

    setPlayer(player);

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!player) {
      return;
    }

    player.on("startRecord", () => {
      startRecord();
    });

    player.on("finishRecord", () => {
      setLoading(true);

      const recordedData = player.recordedData;

      //right now we are using the ffmmpg on the microsoft teams client and push notification on the browsers
      (async () => {
        try {
          if (microsoftTeamsVideoText) {
            await ffmpeg.load();

            ffmpeg.FS("writeFile", "test.webm", await fetchFile(recordedData));
            await ffmpeg.run(
              "-i",
              "test.webm",
              "-preset",
              "ultrafast",
              "-crf",
              "22",
              "test.mp4"
            );

            const output = ffmpeg.FS("readFile", "test.mp4");
            var video_output2 = new File(
              [output.buffer],
              `screen_${new Date().getTime()}.mp4`,
              {
                type: "video/mp4",
              }
            );
          }

          setLoading(false);

          if (microsoftTeamsVideoText) {
            onChange(video_output2);
          } else if (isSafari) {
            var newRecordData = new File(
              [recordedData],
              `screen_${new Date().getTime()}.webm`,
              {
                type: "video/webm",
              }
            );
            onChange(newRecordData);
          } else {
            if (recordedData instanceof Blob) {
              const fileExtension = recordedData.type && recordedData.type.includes('mp4') ? '.mp4' : '.webm';
              const mimeType = recordedData.type || 'video/webm';
              const screenFile = new File(
                [recordedData],
                `screen_${new Date().getTime()}${fileExtension}`,
                {
                  type: mimeType,
                  lastModified: new Date()
                }
              );
              onChange(screenFile);
            } else {
              onChange(recordedData);
            }
          }

          if (disposeAfterRecording) {
            player.dispose();
          }
        } catch (e) {
          console.log(e);
          setLoading(false);
        }
      })();
    });

    //eslint-disable-next-line
  }, [
    player,
    onChange,
    startRecord,
    disposeAfterRecording,
    ffmpeg,
    setLoading,
  ]);

  return (
    <div style={{ position: "relative" }} data-vjs-player ref={containerNode}>
      <video
        ref={videoNode}
        preload="metadata"
        className={classNames({
          "video-js vjs-default-skin": true,
          videoRecorder: true,
        })}
        playsInline
      ></video>
    </div>
  );
};
